"use client";

import { useEffect, useState } from "react";

const PARALLAX_FACTOR = 0.4;
const MAX_OFFSET_PX = 96;

export default function ArticleHeroPattern() {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (motionQuery.matches) return;

    const onScroll = () => {
      setOffsetY(
        Math.min(window.scrollY * PARALLAX_FACTOR, MAX_OFFSET_PX),
      );
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden
      className="absolute inset-x-0 bottom-2 z-[1] h-12 -left-[15px] will-change-transform"
      style={{
        backgroundImage: "url('/icons/hero-pattern-white.svg')",
        backgroundRepeat: "repeat-x",
        backgroundSize: "48px 60px",
        transform: `translate3d(0, -${offsetY}px, 0)`,
      }}
    />
  );
}
